import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { InputTextFormat } from '../../../models/Common';

const macAddress: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '##-##-##-##-##',
  type: 'text',
};

const currency: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  allowNegative: true,
  decimalScale: 2,
  decimalSeparator: '.',
  fixedDecimalScale: true,
  thousandSeparator: ' ',
  allowEmptyFormatting: false,
  isNumericString: false,
  type: 'tel',
};

const phone: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '### ### ## ##',
  type: 'tel',
};

const scratchCardCode: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '##############',
  type: 'tel',
};

const thousandFormat: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  thousandSeparator: ' ',
  allowEmptyFormatting: false,
  isNumericString: false,
  type: 'tel',
};

const contractNumberOrPhone: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '##########',
  type: 'tel',
};

const contractNumber: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '######',
  type: 'tel',
};

const iban: Readonly<NumberFormatProps<typeof NumberFormat>> = {
  prototype: '' as never,
  format: '###########################',
  type: 'tel',
};

export const getInputFormat = (format: InputTextFormat | null) => {
  switch (format) {
    case InputTextFormat.Currency: {
      return currency;
    }
    case InputTextFormat.Phone: {
      return phone;
    }
    case InputTextFormat.ScratchCardCode: {
      return scratchCardCode;
    }
    case InputTextFormat.MacAddress: {
      return macAddress;
    }
    case InputTextFormat.ContractNumberOrPhone: {
      return contractNumberOrPhone;
    }
    case InputTextFormat.ContractNumber: {
      return contractNumber;
    }
    case InputTextFormat.Iban: {
      return iban;
    }
    default:
      return thousandFormat;
  }
};
